// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./Collection.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("0aa2d2e4", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/style/Collection.scss
// module id = 51
// module chunks = 0